module.exports = __webpack_public_path__ + "img/2.a18946f3.jpg";